export const APPLICATION_TYPES = {
    NEW_SWEDISH: 'LLEG_NEW_SWEDISH',
    REG_FOREIGN: 'LLEG_REG_FOREIGN',
    REG_NEW_SWEDISH: 'LLEG_REG_NEW_SWEDISH',
    REG_SPECIAL_SUPPLEMENT: 'LLEG_REG_SPECIAL_SUPPLEMENT',
    REG_SUPPLEMENT_SWEDISH: 'LLEG_REG_SUP_SWEDISH',
    SUPPLEMENT_SWEDISH: 'LLEG_SUP_SWEDISH',
};

export const REG_TYPE_NAMES: {type: string, name: string}[] = [
    {
        name: 'Ärende 3331 - Svensk lärarexamen eller förskollärarexamen',
        type: APPLICATION_TYPES.REG_NEW_SWEDISH,
    },
    {
        name: 'Ärende 3333 - Komplettering av legitimation för legitimerade lärare eller förskollärare',
        type: APPLICATION_TYPES.REG_SUPPLEMENT_SWEDISH,
    },
    {
        name: 'Ärende 3336 - Särskild komplettering',
        type: APPLICATION_TYPES.REG_SPECIAL_SUPPLEMENT,
    },
    {
        name: 'Ärende 3337 - Utländsk lärarexamen',
        type: APPLICATION_TYPES.REG_FOREIGN,
    },
];
